import { fetchSwiper } from '../../../dynamic-modules';
import PageHandlersService from '../../../utils/page-handlers-service';
import gsap from 'gsap';
import { DEVICE_WIDTH } from '../../../utils/viewport-width';
import headerTheme from '@/inits/components/header/header-theme';

const pageHandlers = new PageHandlersService();

const init = async () => {
    if (!DEVICE_WIDTH.isDesktop) {
        const textBlockPictureWrappers = document.querySelectorAll('.js-pr-text-block-picture');

        textBlockPictureWrappers.forEach((pictureWrapper) => {
            if (pictureWrapper.classList.contains('dark')) {
                pictureWrapper.classList.add('js-header-theme-trigger');
                pictureWrapper.setAttribute('data-theme', 'dark');
            }
        });

        headerTheme.destroy();
        headerTheme.init();

        const reviewsSliderContainer = document.querySelector('.js-reviews-slider-container');

        if (reviewsSliderContainer) {
            reviewsSliderContainer.setAttribute('data-theme', 'dark');
        }
    } else {
        const reviewsSliderButtons = document.querySelectorAll('.js-reviews-slider-slide__btn');

        reviewsSliderButtons.forEach((button) => {
            button.classList.remove('btn-light');
            button.classList.add('btn-dark');
        });
    }

    const accordionsGroups = document.querySelectorAll('.js-pr-accordions-group');

    accordionsGroups.forEach((accordionsGroup) => {
        const accordions = accordionsGroup.querySelectorAll('.js-pr-accordion');

        accordions.forEach((accordion) => {
            const label = accordion.querySelector('.js-pr-accordion-label');
            const collapse = accordion.querySelector('.js-pr-accordion-collapse');

            if (label && collapse) {
                const handleLabelClick = () => {
                    if (accordion.classList.contains('active')) {
                        gsap.set(collapse, { height: 0 });

                        accordion.classList.remove('active');
                    } else {
                        accordions.forEach((accordion) => {
                            accordion.classList.remove('active');
                            const collapse = accordion.querySelector('.js-pr-accordion-collapse');

                            gsap.set(collapse, { height: 0 });
                        });

                        accordion.classList.add('active');

                        gsap.set(collapse, { height: collapse.scrollHeight });
                    }
                };

                pageHandlers.set(label, handleLabelClick);
            }
        });
    });

    const videoPlayButton = document.querySelector('.js-video-play-btn');
    const videoPopup = document.querySelector('.js-video-popup');
    const closeButtons = document.querySelectorAll('.js-video-popup-close-btn');
    const videoFrame = document.querySelector<HTMLIFrameElement>('.js-video-popup-frame-container iframe');
    const cursor = document.querySelector('.cursor');

    videoFrame?.classList.add('video-popup__iframe');
    if (videoFrame) {
        videoFrame.dataset.src = videoFrame?.src;
    }

    let videoSrcResetTimeout: NodeJS.Timeout;
    let isFirstTimeOpening = true;

    const handleWatchButtonClick = () => {
        videoPopup?.classList.add('active');
        cursor?.classList.add('cursor--force-hidden');

        if (videoSrcResetTimeout) {
            clearTimeout(videoSrcResetTimeout);
        }

        if (isFirstTimeOpening) {
            videoFrame?.setAttribute('src', videoFrame.dataset.src ?? '');
            isFirstTimeOpening = false;
        }
    };

    const handleCloseButtonClick = () => {
        videoPopup?.classList.remove('active');

        videoSrcResetTimeout = setTimeout(() => {
            videoFrame?.setAttribute('src', videoFrame.src);
            cursor?.classList.remove('cursor--force-hidden');
        }, 600);
    };

    pageHandlers.set(videoPlayButton, handleWatchButtonClick);

    closeButtons.forEach((closeButton) => {
        pageHandlers.set(closeButton, handleCloseButtonClick);
    });


    const { Swiper, Lazy, Pagination } = await fetchSwiper();
    const documentsSliderElement = document.querySelector<HTMLElement>('.js-documents-slider');
    const prevButton = document.querySelector('.js-pr-documents__prev');
    const nextButton = document.querySelector('.js-pr-documents__next');

    const documentsSliderGap =
        window.innerWidth > 1366 ? 60 : window.innerWidth > 1024 ? 40 : window.innerWidth > 767 ? 24 : 15;

    if (documentsSliderElement && prevButton && nextButton) {
        const documentsSlider = new Swiper(documentsSliderElement, {
            modules: [Lazy],
            slidesPerView: 'auto',
            speed: 500,
            spaceBetween: documentsSliderGap,
        });

        const handleSliderPrev = () => documentsSlider.slidePrev();
        const handleSliderNext = () => documentsSlider.slideNext();

        pageHandlers.set(prevButton, handleSliderPrev);
        pageHandlers.set(nextButton, handleSliderNext);

        const destroySlider = () => {
            documentsSlider.destroy();
        };

        pageHandlers.addDestroy(destroySlider);
    }

    // Скрытие стрелок если количество документов недостаточное
    const documentItems = document.querySelectorAll('.js-pr-document');

    if (documentsSliderElement) {
        if (documentItems.length > 0) {
            const handleSliderControls = () => {
                const documentItemsSummaryWidth =
                    documentItems.length * documentItems[0].clientWidth +
                    documentsSliderGap * (documentItems.length - 1);

                const sliderStyle = getComputedStyle(documentsSliderElement);
                const pagePadding = parseFloat(sliderStyle.getPropertyValue('padding-left'));

                const isControlsUseless =
                    documentItemsSummaryWidth <= documentsSliderElement.clientWidth - pagePadding * 2;

                if (isControlsUseless) {
                    documentsSliderElement.classList.add('disabled-controls');
                } else {
                    documentsSliderElement.classList.remove('disabled-controls');
                }
            };

            handleSliderControls();

            pageHandlers.set(window, handleSliderControls, 'resize');
        } else {
            documentsSliderElement.classList.add('disabled-controls');
        }
    }
};

const destroy = () => pageHandlers.clear();

const _module = { init, destroy };

export default _module;
